var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCopy = function SvgCopy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 13,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#828D99",
    fillRule: "evenodd",
    d: "M1.447 3.82C1 4.382 1 5.185 1 6.79v.857c0 1.605 0 2.408.447 2.97q.22.274.518.474c.615.409 1.493.409 3.25.409 1.755 0 2.633 0 3.248-.409q.3-.2.518-.473c.447-.563.447-1.366.447-2.971V6.79c0-1.605 0-2.408-.447-2.97a2.3 2.3 0 0 0-.518-.474c-.615-.409-1.493-.409-3.249-.409s-2.634 0-3.249.409a2.3 2.3 0 0 0-.518.474",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#copy_svg__a)",
    fillRule: "evenodd",
    d: "M3.341 5.185c-.194 0-.351.144-.351.321s.157.321.351.321h3.746c.194 0 .351-.144.351-.321s-.157-.321-.35-.321zm0 1.712c-.194 0-.351.144-.351.322 0 .177.157.32.351.32h3.746c.194 0 .351-.143.351-.32s-.157-.322-.35-.322zm0 1.713c-.194 0-.351.144-.351.321s.157.321.351.321h3.746c.194 0 .351-.144.351-.32 0-.178-.157-.322-.35-.322z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#A6ACB3",
    d: "M3.019 2.382q-.142.179-.228.396c.594-.2 1.432-.2 2.816-.2 1.756 0 2.634 0 3.25.409q.299.2.517.473c.447.563.447 1.366.447 2.971v.856c0 1.266 0 2.032-.219 2.576q.238-.08.433-.209.3-.2.518-.474C11 8.618 11 7.815 11 6.21v-.857c0-1.605 0-2.408-.447-2.97a2.3 2.3 0 0 0-.518-.474C9.42 1.5 8.542 1.5 6.785 1.5c-1.755 0-2.633 0-3.248.409a2.3 2.3 0 0 0-.518.473"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "copy_svg__a",
    x1: 6.084,
    x2: 19.886,
    y1: 13.63,
    y2: 0.101,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.2
  })))));
};
export { SvgCopy as ReactComponent };